import 'core-js/full/error/index.js';
import 'core-js/full/aggregate-error.js';
import 'core-js/full/atob.js';
import 'core-js/full/btoa.js';
import 'core-js/full/dom-exception/index.js';
import 'core-js/full/structured-clone.js';
import 'core-js/full/url/index.js';
import 'core-js/full/url-search-params/index.js';
